import React from 'react';
import Header from '../components/header/CustomHeader';
import SliderSection from '../components/layouts/home/SliderSection';
import ContributorSection from '../components/layouts/home/ContributorSection';
import PremiumSection from '../components/layouts/home/PremiumSection';
import NewsSection from '../components/layouts/home/NewsSection';
import EventSection from '../components/layouts/home/EventSection';
import DirectorySection from '../components/layouts/home/DirectorySection';
import NFTShowcaseSection from '../components/layouts/home/NFTShowcaseSection';
import CustomFooter from '../components/footer/CustomFooter';

const Home01 = () => {
    return (
        <div className='home-1'>
            <Header active={'Home'}/>
            <SliderSection/>
            <ContributorSection/>
            <PremiumSection/>
            <NewsSection/>
            <EventSection/>
            <DirectorySection/>
            <NFTShowcaseSection/>
            <CustomFooter/>
        </div>
    );
}

export default Home01;
